// src/services/api.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

// Response interceptor for error normalization
client.interceptors.response.use(
  (res) => res,
  (err) => {
    const message =
      err.response?.data?.detail ||
      err.response?.data?.message ||
      err.message ||
      'Network error';
    return Promise.reject(new Error(message));
  }
);

// ─── Site Config ───────────────────────────────────────────────
export const fetchSiteConfig = () =>
  client.get('/config/').then((r) => r.data);

// ─── Features ──────────────────────────────────────────────────
export const fetchFeatures = () =>
  client.get('/features/').then((r) => r.data);

// ─── Categories ────────────────────────────────────────────────
export const fetchCategories = () =>
  client.get('/categories/').then((r) => r.data);

// ─── Portfolio ─────────────────────────────────────────────────
export const fetchPortfolio = (params = {}) =>
  client.get('/portfolio/', { params }).then((r) => r.data);

export const fetchFeaturedPortfolio = () =>
  client.get('/portfolio/featured/').then((r) => r.data);

export const fetchPortfolioItem = (slug) =>
  client.get(`/portfolio/${slug}/`).then((r) => r.data);

// ─── Testimonials ──────────────────────────────────────────────
export const fetchTestimonials = (params = {}) =>
  client.get('/testimonials/', { params }).then((r) => r.data);

export const fetchFeaturedTestimonials = () =>
  client.get('/testimonials/featured/').then((r) => r.data);

// ─── Articles ──────────────────────────────────────────────────
export const fetchArticles = (params = {}) =>
  client.get('/articles/', { params }).then((r) => r.data);

export const fetchFeaturedArticles = () =>
  client.get('/articles/featured/').then((r) => r.data);

export const fetchArticle = (slug) =>
  client.get(`/articles/${slug}/`).then((r) => r.data);

export const fetchArticleTags = () =>
  client.get('/article-tags/').then((r) => r.data);

// ─── FAQs ──────────────────────────────────────────────────────
export const fetchFAQs = () =>
  client.get('/faqs/').then((r) => r.data);
